import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLocationPinCircleSolidIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 44 44",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		filter: "url(#filter0_d_7159_91252)",
		children: [/* @__PURE__ */ _jsx("rect", {
			x: 1.668,
			y: .834,
			width: 40,
			height: 40,
			rx: 20,
			fill: "currentColor"
		}), /* @__PURE__ */ _jsx("path", {
			d: "M15.668 18.024c0-3.204 2.654-5.858 6-5.858s6 2.654 6 5.858c0 1.9-.992 4.23-2.454 6.546-1.18 1.867-2.542 3.534-3.546 4.671-1.004-1.137-2.363-2.8-3.546-4.67-1.462-2.313-2.454-4.647-2.454-6.547m6-7.858c-4.417 0-8 3.517-8 7.858 0 4.971 5.008 10.93 7.1 13.2a1.21 1.21 0 0 0 1.8 0c2.092-2.27 7.1-8.229 7.1-13.2 0-4.341-3.583-7.858-8-7.858m-1.333 8c0-.738.595-1.333 1.333-1.333s1.333.596 1.333 1.333c0 .738-.596 1.333-1.333 1.333a1.33 1.33 0 0 1-1.333-1.333m4.666 0a3.33 3.33 0 0 0-3.333-3.333 3.332 3.332 0 1 0 0 6.666 3.33 3.33 0 0 0 3.333-3.333",
			fill: "#fff"
		})]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsxs("filter", {
		id: "filter0_d_7159_91252",
		x: .001,
		y: .001,
		width: 43.333,
		height: 43.333,
		filterUnits: "userSpaceOnUse",
		colorInterpolationFilters: "sRGB",
		children: [
			/* @__PURE__ */ _jsx("feFlood", {
				floodOpacity: 0,
				result: "BackgroundImageFix"
			}),
			/* @__PURE__ */ _jsx("feColorMatrix", {
				in: "SourceAlpha",
				values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
				result: "hardAlpha"
			}),
			/* @__PURE__ */ _jsx("feOffset", { dy: .833 }),
			/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: .833 }),
			/* @__PURE__ */ _jsx("feColorMatrix", { values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" }),
			/* @__PURE__ */ _jsx("feBlend", {
				in2: "BackgroundImageFix",
				result: "effect1_dropShadow_7159_91252"
			}),
			/* @__PURE__ */ _jsx("feBlend", {
				in: "SourceGraphic",
				in2: "effect1_dropShadow_7159_91252",
				result: "shape"
			})
		]
	}) })]
});
export default SvgLocationPinCircleSolidIcon;
